import { useGetFormattedDurationFieldLabels } from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Stack, Typography } from '@mui/material';

interface CompareDurationDefinitionInfoProps {
  compareField: 'A' | 'B';
}

export const CompareDurationDefinitionInfo = ({
  compareField,
}: CompareDurationDefinitionInfoProps) => {
  const compareTo = useQuantifyStore(({ query }) => query.compareQuery);

  const { durationLabel, compareDurationLabel } =
    useGetFormattedDurationFieldLabels();

  if (!!compareTo?.timerange && compareTo?.previousPeriod) {
    return null;
  }

  if (compareField === 'A') {
    return (
      <Stack>
        <Typography variant="caption">{durationLabel.primary}</Typography>
        {durationLabel.secondary && (
          <Typography variant="caption">{durationLabel.secondary}</Typography>
        )}
      </Stack>
    );
  }

  return (
    <Stack>
      <Typography variant="caption">{compareDurationLabel.primary}</Typography>
      {compareDurationLabel.secondary && (
        <Typography variant="caption">
          {compareDurationLabel.secondary}
        </Typography>
      )}
    </Stack>
  );
};
